var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ fill: "#51C6E5", width: "100pt", height: "100pt", viewBox: "0 0 100 100", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M80.387 13.719a4.173 4.173 0 0 1 5.894 0 4.173 4.173 0 0 1 0 5.894l-37.5 37.5a4.173 4.173 0 0 1-5.894 0 4.173 4.173 0 0 1 0-5.894z" }),
    React.createElement("path", { d: "M79.168 20.832H62.5a4.166 4.166 0 1 1 0-8.332h20.832a4.17 4.17 0 0 1 4.168 4.168V37.5a4.166 4.166 0 1 1-8.332 0zM70.832 56.25c0-2.3 1.867-4.168 4.168-4.168s4.168 1.867 4.168 4.168v23.438c0 6.617-5.363 11.98-11.98 11.98H20.313c-6.617 0-11.98-5.363-11.98-11.98V32.813c0-6.617 5.363-11.98 11.98-11.98h25.391c2.3 0 4.168 1.867 4.168 4.168s-1.867 4.168-4.168 4.168H20.313a3.646 3.646 0 0 0-3.644 3.644v46.875a3.646 3.646 0 0 0 3.644 3.645h46.875a3.646 3.646 0 0 0 3.644-3.644z" })
  );
});